import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';
import ExcelJS from 'exceljs';
import { RESPONDER_SETTINGS } from '../ui/components/common/reviewComponents/settings';
import { lowReasoningEffortFloorLlms } from '../ui/components/common/constant';
import { saveAs } from 'file-saver';
export const defaultGuid = '00000000-0000-0000-0000-000000000000';

export const getAuthToken = () => {
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const authTokenStorage = localStorage.getItem(`@@auth0spajs@@::${clientId}::@@user@@`);
  return JSON.parse(authTokenStorage)?.id_token;
}
// True when the cached ID token has expired or expires within a minute. No token at all is not "expired":
// the user simply has not signed in yet.
export const isAuthTokenExpired = () => {
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const exp = JSON.parse(localStorage.getItem(`@@auth0spajs@@::${clientId}::@@user@@`))?.decodedToken?.claims?.exp;
  return !!exp && exp * 1000 < Date.now() + 60 * 1000;
}
export const convertArrayToDictionary = (array, id) => {
  var obj = {};
  _.map(array, (item) => {
    if (id) {
      obj[item[id]] = item;
    } else {
      obj[item] = item;
    }
    return item;
  })
  return obj;
};
export const filterByValues = (collection, key, values) => {
  return _.filter(collection, function (o) {
    return _.includes(values, resolveKey(o, key));
  });
};
export const resolveKey = (obj, key) => {
  if (obj === null || key === null) {
    return undefined;
  }
  var resolved = undefined;
  if (typeof key === 'function') {
    resolved = key(obj);
  } else if (typeof key === 'string') {
    resolved = obj[key];
    if (resolved === null && key.indexOf(".") !== -1) {
      resolved = _.deepGet(obj, key);
    }
  }
  return resolved;
};
export const isEmpty = (value) => {
  return _.isEmpty(value);
};

export const isEmpty2 = function (value, allowEmptyString) {
  return (value === ' ') || (value === null) || (value === undefined) || (!allowEmptyString ? value === '' : false) || (isArray(value) && value.length === 0);
};
export const isArray = ('isArray' in Array) ? Array.isArray : function (value) {
  return toString.call(value) === '[object Array]';
};
export const getUserId = () => {
  return localStorage.getItem('userId') ? localStorage.getItem('userId') : null;
}
export const getNumeric = (value, isDecimal) => {
  if (isDecimal) {
    return numeral(value).format('0,0[.]0');
  } else {
    return numeral(value).format('0,0');
  }
}
export const promptOutputDnd = [
  { value: 1, label: 'Separate Json' },
  { value: 2, label: 'Combined Json' },
  { value: 3, label: 'Visual' },
]
export const reviewProcessDnd = [
  { value: 50, label: '50 Reviews' },
  { value: 100, label: '100 Reviews' },
  { value: 500, label: '500 Reviews' },
  { value: 1000, label: '1000 Reviews' },
  { value: 5000, label: '5000 Reviews', isSeparater: true },
  { value: moment().add(-1, 'months').format('YYYY-MM-DD'), label: '1 Month' },
  { value: moment().add(-3, 'months').format('YYYY-MM-DD'), label: '3 Months' },
  { value: moment().add(-6, 'months').format('YYYY-MM-DD'), label: '6 Months' },
  { value: moment().add(-1, 'years').format('YYYY-MM-DD'), label: '1 Year' },
  { value: moment().add(-2, 'years').format('YYYY-MM-DD'), label: '2 Years', isSeparater: true },
  { value: 1, label: 'All Reviews' },
]
export const getCompanyId = () => {
 const tabId=sessionStorage.getItem('env')
  return localStorage.getItem('company') && JSON.parse(localStorage.getItem('company'))[tabId] ? JSON.parse(localStorage.getItem('company'))[tabId] : null;
}
export const userDic = {
  "2c6859fb-7b5f-4516-88c4-40d3ca04e502": "Akhilesh Gupta",
  "db7644d1-eb35-44c6-9592-0a4e28be6ff3": "Archna Chaudhary",
  "3662a778-ca61-46a2-8f3a-9c187f6bf2ea": "Prashant Singh",
  "2a065103-bfd6-4433-85e8-c799d920e709": "Ram Pujan Singh",
  "be196ea4-1a15-480c-bdb6-21c7629d987f": "Dileep Kumar",
  "58d9bf94-14b1-487f-86f0-b899655fbf5f": "Jatin Kashyap",
  "6d972148-d6ec-4924-9d9b-e71ee1c22c61": "Shiv Pujan Singh",
  "07cbb938-8fea-4b28-b0e1-6e593c65a82e": "Hemant Varshney",
  "73ebdfb5-008c-42dc-99e0-f16ac1238b39": "Abhishek Yadav",
  "49fee77b-51ba-4e7f-a7f2-8453325adb48": "Deepali chaudhary",
  "3e5fbc81-51f2-4a26-9804-1c4b533afeaf": "Shiv Pujan Singh",
  "506caff2-7e2c-49a6-a0dd-da8fe3071bf0": "Dileep Outlook",
  "cea4382e-0707-4954-8b0f-e8d18ddecb4e": "Martin Lenardon",
  "6e3054e1-0080-4885-9d14-9dc62b94dd3c": "Sabrina Hu",
  "b287f315-ca8f-472b-82b1-0829a48db8eb": "George Swetlitz",
  "5acecca7-e694-41bd-b342-af5c3ef695d4": "George Swetlitz",
  "c91363e3-4202-4453-952a-8529152824d7": "George Swetlitz",

}
/**
 * Generates an Excel file with specified data, formatting, and file name.
 * @param {Array} data - The array of objects containing the data to be exported.
 * @param {string} fileName - The desired name for the Excel file (without extension).
 * @param {Array} columns - The array of column configurations including formatting information.
 *   Each column object should have the following properties:
 *   - header: The display name for the column.
 *   - key: The key to retrieve data for the column from the data array.
 *   - formatting (optional): An object specifying formatting information for the column.
 *     - type: The type of formatting ('number' or 'text').
 *     - format (optional): The number format code for numbers (applicable only if type is 'number').
 */
export const generateExcelFile = async (data, fileName, columns) => {
  // Create a new Excel workbook and add a worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet 1');

  // Add header row to worksheet with formatting
  const headerRow = worksheet.addRow(columns.map(column => column.header));
  headerRow.eachCell((cell, index) => {
    cell.font = { family: 2, size: 12 };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '8DB4E2' } };
    cell.alignment = { horizontal: 'left' }; // Default alignment is 'left'
    cell.border = {
      top: { style: 'thin', color: { argb: '5c9cd4' } },
      left: { style: 'thin', color: { argb: '5c9cd4' } },
      bottom: { style: 'thin', color: { argb: '5c9cd4' } },
      right: { style: 'thin', color: { argb: '5c9cd4' } },
    };

    // Apply column formatting if provided
    const columnFormatting = columns[index]?.formatting;
    if (columnFormatting) {
      if (columnFormatting.type === 'number') {
        // Apply number formatting
        cell.numFmt = columnFormatting?.format;
        cell.alignment = { horizontal: 'right' };
      } else if (columnFormatting?.type === 'text') {
        // Apply text formatting
        cell.alignment = { horizontal: 'left' }; // You can adjust this based on your needs
      }
    }
  });

  // Add data rows to worksheet with alternating row colors for entire rows
  data.forEach((rowData, index) => {
    const excelRow = worksheet.addRow(columns.map(column => rowData[column.key]));

    excelRow.eachCell((cell, cellIndex) => {
      const column = columns[cellIndex];

      // Apply cell border
      worksheet.getCell(cell.address).border = {
        top: { style: 'thin', color: { argb: '5c9cd4' } },
        left: { style: 'thin', color: { argb: '5c9cd4' } },
        bottom: { style: 'thin', color: { argb: '5c9cd4' } },
        right: { style: 'thin', color: { argb: '5c9cd4' } },
      };

      // Apply cell formatting if provided
      const cellFormatting = column?.formatting;
      if (cellFormatting) {
        if (cellFormatting?.type === 'number') {
          // Apply number formatting
          cell.numFmt = cellFormatting?.format;
          cell.alignment = { horizontal: 'right' };
        } else if (cellFormatting?.type === 'text') {
          // Apply text formatting
          cell.alignment = { horizontal: 'left' }; // You can adjust this based on your needs
        }
      }
    });

    // Apply alternating row color
    if (index % 2 === 0) {
      excelRow.eachCell((cell) => {
        worksheet.getCell(cell.address).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'DEEAF6' },
        };
      });
    }
  });

  // Auto-size columns based on content
  worksheet.columns.forEach((column, i) => {
    const values = worksheet.getColumn(i + 1).values.map((cell) => (cell ? cell.toString() : ''));
    const filteredValues = values.filter((cell) => typeof cell === 'string');

    if (filteredValues.length > 0) {
      const maxLength = Math.max(...filteredValues.map((cell) => cell.length));
      column.width = maxLength < 20 ? 20 : maxLength; // Set a minimum width of 20
    } else {
      column.width = 20;
    }
  });

  // Save the workbook to a file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);

  // Trigger download
  const link = document.createElement('a');
  link.href = url;
  const downloadName = (fileName ? fileName : 'excelExport') + '.xlsx';
  link.download = downloadName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getSourceIcon = (source, size, isAll) => {
  const sourceValue = isAll ? 'All' : source;
  const sourceOIcon = (<i class="fi fi-sr-database" style={{ fontSize: size - 2, color: '#3E4853' }}></i>)
  switch (source) {
    // case 0:
    //   return sourceOIcon

    default:
      return <img loading="lazy" style={{
        width: `${size ? size : 48}px`,
        height: `${size ? size : 48}px`
      }} src={`https://static.rightresponse.ai/sources/${sourceValue}.ico`}
        onError={(e) => { e.target.onerror = null; e.target.src = "https://static.rightresponse.ai/sources/x.ico" }}
      />;
  }
};
export const getSalutationSettings=(companyId)=>{
  if(!companyId)return {}
  const localstorageData=localStorage.getItem(RESPONDER_SETTINGS)
  if(!localstorageData)return {}
  if(!JSON.parse(localstorageData)) return {}
  const parsedData=JSON.parse(localstorageData)
  if(parsedData[companyId]) return parsedData[companyId]
}

export const uTCtoLocalforTime = (date, onlyDate = false, onlyTime = false, format) => {
  if (!date) return '';
  const utcDate = moment.utc(date);
  const localTimezone = moment.tz.guess();
  const localDate = utcDate.tz(localTimezone);
  if (onlyDate || moment(date).format('HH:mm:ss') === '00:00:00') {
      return localDate.format('MM/DD/YYYY');
  }
  if (onlyTime && moment(date).format('HH:mm:ss') !== '00:00:00') {
      return localDate.format('hh:mm:ss A z'); 
  }
  return localDate.format(format || 'MM/DD/YYYY hh:mm:ss A z');
 };




export const periodTypes={years:0,quarters:1,month:2,weekStartMonday:3,weekStartSunday:4,days:5};
export const mainTypes={betweeen:0,on:1,before:2,after:3,last:4,current:5,allTime:7,custom:6};
export const getDateRangeFromString=(string)=>{
  const obj={}
  if(!string || string===''||typeof string!=='string'){
    return null
  }
  const splitString=_.split(string,';');
  const mainType=mainTypes[String(splitString[0].replace(/\s/g, '')).charAt(0).toLowerCase() + String(splitString[0].replace(/\s/g, '')).slice(1)]
  switch (mainType) {
      case 0:
          obj['mainType']=0
          obj['start']=splitString[1]
          obj['end']=splitString[2]
          break;
      case 1:
          obj['mainType']=1
          obj['start']=splitString[1]
          break;
      case 2:
          obj['mainType']=2
          obj['start']=splitString[1]
          break;
      case 3:
          obj['mainType']=3
          obj['start']=splitString[1]
          break;
      case 4:
          obj['mainType']=4
          obj['days']=splitString[1]
          obj['periodType']=periodTypes[splitString[2]]
          obj['included']=splitString[3]==='true'?true:false
          break;
      case 5:
          obj['mainType']=5
          obj['periodType']=periodTypes[splitString[1]]
          break;
      case 6:
          obj['mainType']=0
          obj['start']=splitString[1]
          obj['end']=splitString[2]
          break;  
      case 7:
          obj['mainType']=7
      default:
          break;
  }
  return obj

}
export const setDateRangeToString=(startDate,endDate,range)=>{
  const invertedMainTypes=_.invert(mainTypes)
  const invertedPeriodTypes=_.invert(periodTypes)
  const mainType=_.startCase(invertedMainTypes[range[0]])
  const periodType=invertedPeriodTypes[range[1]]
  switch (mainType) {
      case 'Betweeen':
          return `${mainType};${startDate};${endDate}`
      case 'On':
          return `${mainType};${startDate}`
      case 'Before':
          return `${mainType};${endDate?endDate:moment().format('YYYY-MM-DD')}`
      case 'After':
          return `${mainType};${startDate};${moment().format('YYYY-MM-DD')}`
      case 'Last':
          return `${mainType};${range[2]??1};${periodType};${range[3]?true:false}`
      case 'Current':
          return `${mainType};${periodType}`
      case 'Custom':
          return `${mainType};${startDate};${endDate}`
          case 'All Time':
          return `${mainType}`
      default:
          break;
  }
}



export const handleExportExcel = async(tableDataMemo,tableColumns=null,name,isCsv,sheetName="Data") => {
    const fileName = `${name} ${moment().format("YYYYMMDD")}-${moment().format("hhmmss")}`;
    const workbook = new ExcelJS.Workbook();

   const columns=tableColumns?tableColumns:_.map(_.keys(tableDataMemo[0]), it => ({key:it}))

    const worksheet = workbook.addWorksheet(sheetName);
    let headers = _.map(tableColumns, it => it.header);
    worksheet.getRow(1).values = headers;
    worksheet.columns = columns;
    debugger
//     worksheet.columns.forEach(function (column, i) {
//       let maxLength = 0;
//       column["eachCell"]({ includeEmpty: true }, function (cell) {
//           var columnLength = cell.value ? cell.value.toString().length : 10;
//           if (columnLength > maxLength ) {
//               maxLength = columnLength;
//           }
//       });
//       column.width = maxLength < 10 ? 10+2 : maxLength+2;
//   });
 tableDataMemo?.forEach(function (item, index) {
     const row=  worksheet.addRow(item)
     row.eachCell({ includeEmpty: false }, function (cell) {
      worksheet.getCell(cell.address).border = {
        top: { style: "thin", color: { argb: "5c9cd4" } },
        left: { style: "thin", color: { argb: "5c9cd4" } },
        bottom: { style: "thin", color: { argb: "5c9cd4" } },
        right: { style: "thin", color: { argb: "5c9cd4" } },
      };
      worksheet.getCell(cell.address).alignment={
          wrapText: true
        }
    });
    if (index % 2 === 0) {

      row.eachCell({ includeEmpty: false }, function (cell) {
        worksheet.getCell(cell.address).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "DEEAF6" },
          
        };
        worksheet.getCell(cell.address).alignment={
          wrapText: true
        }
      });
    }
      })
worksheet.getRow(1).eachCell({ includeEmpty: false }, function (cell) {
          worksheet.getCell(cell.address).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "8DB4E2" },
          };
          worksheet.getCell(cell.address).font = {
            color: { argb: "0000000" },
            family: 2,
            size: 12,
          };
          worksheet.getCell(cell.address).border = {
            top: { style: "thin", color: { argb: "5c9cd4" } },
            left: { style: "thin", color: { argb: "5c9cd4" } },
            bottom: { style: "thin", color: { argb: "5c9cd4" } },
            right: { style: "thin", color: { argb: "5c9cd4" } },
          };
          worksheet.getCell(cell.address).alignment = {
            horizontal: "center",
            
          };
        });
        if(isCsv){
            const csvBuffer = await workbook.csv.writeBuffer();

            // Create a blob from the buffer
            const blob = new Blob([csvBuffer], { type: 'text/csv;charset=utf-8;' });
        
            // Use FileSaver to save the blob as a file
           return saveAs(blob, `${fileName}.csv`);
        }
    workbook.xlsx.writeBuffer().then(function (data) {
      var blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${fileName}.xlsx`);
    });
  };

export const promptTypesData = (promptTypes) => {
      let data = _.reduce(
        promptTypes,
        (acc, item) => {
          if (!acc[item.promptType]) {
            acc[item.promptType] = [];
          }
          if (item.promptSubType) {
            acc[item.promptType].push(item.promptSubType);
          }
          return acc;
        },
        {}
      );
      data = _.mapValues(data, (subTypes) => _.orderBy(subTypes));
      data["Other"] = data["Other"] || [];
      if (!data["Other"].includes("Custom")) {
        data["Other"].push("Custom");
      }
  
      for (const type in data) {
        if (!data[type].includes("Custom")) {
          data[type].push("Custom");
        }
      }
      const sortedKeys = Object.keys(data).filter(k => k !== 'Other').sort();
      if (data['Other']) sortedKeys.push('Other');
      return Object.fromEntries(sortedKeys.map(key => [key, data[key]]));
    }
  
 export  const promptTypesOptions = (promptTypes, searchTerm) => {
      if (!searchTerm) {
        return promptTypesData(promptTypes);
      }
      const searchText = _.toLower(searchTerm);
      return _.reduce(
        promptTypesData(promptTypes),
        (acc, subTypes, type) => {
          
          const typeMatche = _.includes(_.toLower(type), searchText);
          const filteredSubTypes = subTypes.filter((subType) =>
            _.includes(_.toLower(subType), searchText)
          );
          if (typeMatche) {
            acc[type] = subTypes; 
          } else if (filteredSubTypes.length > 0) {
            acc[type] = filteredSubTypes;
          }
          return acc;
        },
        {}
      );
    }

export const hasLowReasoningEffortFloor = (llm) => _.some(lowReasoningEffortFloorLlms, (m) => _.includes(llm, m))

export const normalizeReasoningEffort = (llm, value) =>
  hasLowReasoningEffortFloor(llm) && _.includes(['none', 'minimal'], _.toLower(value)) ? 'low' : value

export const getDefailtGpt5xVal = (llm, defaultValue = 'minimal')=>{
  if (hasLowReasoningEffortFloor(llm)) return 'low'
  return (llm===`gpt-5.1` || llm===`gpt-5.2` || _.includes(llm, `gpt-5.4`) || _.includes(llm, `gpt-5.6`) || _.includes(llm, `gpt-6`))?'none': defaultValue
}